import "@fontsource/roboto"

import "./src/styles/foundation/variable.css"
import "./src/styles/foundation/normalize.css"
import "./src/styles/foundation/base.css"
import "./src/styles/foundation/blog-contents-style.css"

let loadingTimer

export const onPreRouteUpdate = () => {
  // 初回アクセスでは表示しない
  if (!sessionStorage.getItem("page-loaded")) {
    return
  }

  document.body.classList.remove("is-page-loading-end")
  document.body.classList.add("is-page-loading")
}

export const onRouteUpdate = () => {
  // 初回アクセス
  if (!sessionStorage.getItem("page-loaded")) {
    sessionStorage.setItem("page-loaded", "true")
    return
  }

  clearTimeout(loadingTimer)

  loadingTimer = setTimeout(() => {
    document.body.classList.remove("is-page-loading")
    document.body.classList.add("is-page-loading-end")

    setTimeout(() => {
      document.body.classList.remove("is-page-loading-end")
    }, 700)
  }, 800)
}